import { IGroupedEvent } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { dateProvider } from '@utils';
import { useMemo } from 'react';

import { sdk } from '@/services';

const EventService = sdk.getService('EventService');

export const useWidgetNextEvents = () => {
  const queryKey = ['events', 'widget', 'next-events'];
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => EventService.getEventsWidgetNextEvents()
  });
  const filteredData = useMemo(() => data ?? [], [data]);

  const groupedEventsByDate = useMemo(() => {
    if (!filteredData) return [];

    const grouped = filteredData.reduce((acc, event) => {
      const dateKey = dateProvider.format(event.startDate.dateTime, 'dd/MM/yyyy');
      const originalDate = dateProvider.zonedTimeToUtc(event.startDate);

      const existingGroup = acc.find(group => group.dateKey === dateKey);
      if (existingGroup) {
        existingGroup.events.push(event);
      } else {
        acc.push({
          dateKey,
          originalDate,
          events: [event]
        });
      }
      return acc;
    }, [] as IGroupedEvent[]);

    return grouped.sort((a, b) => a.originalDate.getTime() - b.originalDate.getTime());
  }, [filteredData]);

  return {
    events: filteredData,
    groupedEventsByDate,
    isLoading
  };
};
